import React from "react";

import LoadingWithIcon from "../../shared/Loading/LoadingIcon";

const SuspenseLoading = () => <LoadingWithIcon />;

export default SuspenseLoading;
